import { CButton, CCard, CCardBody, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel, CFormSelect, CFormInput, CFormText, CFormCheck } from '@coreui/react'
import React from 'react'
import { useState, useRef } from 'react'
import CustomAgGrid from './../../components/shared/CustomAgGrid'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import SaveDiagnosisData from '../../services/general/saveDiagnosisData.api'
import DeleteDiagnosis from '../../services/general/deleteDiagnosis.api'
import { Form } from '@formio/react'
import FacilityCRUD from '../../services/general/getFacilityData.api.js'
import FacilityTypeFn from '../../services/general/modifyFacilityType.api'
import './dashboard.css'

import axios from 'axios'
import { useEffect } from 'react'
import CustomDropdown from './../../components/shared/CustomDropdown'
import Pageloader from '../../components/shared/Pageloader'

const FacilityType = () => {
  const update = useRef('EDIT')
  const facilityID = useRef('-1')
  const [options, setOptions] = useState(['square', 'triangle', 'circle', 'pentagon', 'pin', 'H', 'E', 'S', 'A', 'I', 'M', 'N', 'T', 'X' ,'L','ARH','SNF','ALF','MC','ILF','ALF/MC', 'CCRC',"GH"])
  const [selected, setSelected] = useState(options[0])
  const [isPageLoading, setIsPageLoading] = useState(false)

  const onSelect = (e) => {
    const newValue = e.target.value

    setSelected(newValue)
  }
  const [deleteConfirmVisible, setDeleteConfirmVisible] = useState(false)
  const [facilityToDelete, setFacilityToDelete] = useState(null)

  const updateFacility = async (type, e) => {
    facilityID.current = e.id
    update.current = type
    if (type == 'DELETE') {
      setFacilityToDelete(e)
      setDeleteConfirmVisible(true)
    } else if (type == 'EDIT') {
      setInputValue(e.Name)
      setSelected(e.Marker)
      setModalVisible((e) => !e)
    }
  }

  const confirmDelete = async () => {
    if (facilityToDelete) {
      let a = await callFn('DELETE', { id: facilityToDelete.id, name: facilityToDelete.Name })
      await getData()
      setDeleteConfirmVisible(false)
      setFacilityToDelete(null)
    }
  }

  const buttonList = [
    { Name: 'Edit', FunctionName: updateFacility },
    { Name: 'Delete', FunctionName: updateFacility },
  ]
  const [diagnosisData, setDiagnosisData] = useState('')
  const [selectedValue, setSelectedValue] = useState('')

  const [modalVisible, setModalVisible] = useState(false)
  const [inputValue, setInputValue] = useState('')

  const facilityName = useRef('')

  const handleonClick = (e) => {
    update.current = 'INSERT'
    setInputValue('')
    setSelectedValue('')
    setModalVisible((e) => !e)
  }

  const saveFacility = async () => {
    let name = inputValue
    let a = await callFn(update.current, { id: facilityID.current, name, selected })
    await getData()
    setModalVisible(false)
  }

  const callFn = async (type, obj) => {
    let c = await FacilityTypeFn(type, obj.id, obj.name, obj.selected)
    return c
  }

  const getData = async () => {
    setIsPageLoading(true)
    try {
      let a = await callFn('SELECT', { id: '', name: '' })
      let data = JSON.parse(a.d)
      setDiagnosisData(a.d)
    } catch (error) {
      console.log(error)
    } finally { 
      setIsPageLoading(false)
    }
  }

  useEffect(() => {
    let a = getData()
  }, [])

  return (
    <>
      <div className="position-relative facility-type-theme dashboard-dark-theme patient-theme-page patient-page-wrapper">
        <Pageloader isLoading={isPageLoading} />
        <CCard className="m-2 facility-type-theme__toolbar">
          <CCardBody className="facility-type-theme__toolbar-body">
            <CButton className="m-2 ui-action-btn ui-action-btn--primary" onClick={handleonClick}>
              + Add Facility Type
            </CButton>
          </CCardBody>
        </CCard>

        <div className="facility-type-theme__grid">
          <CustomAgGrid rowClickedFn={updateFacility} callFrom="Facility" options={diagnosisData} btnList={buttonList}></CustomAgGrid>
        </div>

        <CModal className="dashboard-dark-modal facility-type-theme__modal" size="md" backdrop={'static'} visible={modalVisible} onClose={() => setModalVisible(false)}>
          <CModalHeader className="dashboard-dark-modal-header" onClose={() => setModalVisible(false)}>
            <CModalTitle>Add Facility Type</CModalTitle>
          </CModalHeader>
          <CModalBody className="dashboard-dark-modal-body">
            <div className="mb-3">
              <CFormLabel>Type Name</CFormLabel>
              <CFormInput value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
            </div>
            <div className="mb-3">
              <CFormLabel>Marker Type</CFormLabel>
              <CustomDropdown options={options} onSelect={onSelect} selected={selected}></CustomDropdown>
            </div>
          </CModalBody>
          <CModalFooter className="dashboard-dark-modal-footer">
            <CButton className="ui-action-btn ui-action-btn--secondary" color="secondary" onClick={() => setModalVisible(false)}>
              Close
            </CButton>
            <CButton className="ui-action-btn ui-action-btn--primary" color="primary" onClick={() => saveFacility()}>
              Save Changes
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          visible={deleteConfirmVisible}
          onClose={() => setDeleteConfirmVisible(false)}
          centered
          backdrop="static"
          className="hrm-confirm-modal"
        >
          <CModalHeader onClose={() => setDeleteConfirmVisible(false)}>
            <CModalTitle>Delete Facility Type</CModalTitle>
          </CModalHeader>
          <CModalBody>
            Are you sure you want to delete{facilityToDelete?.Name ? <> <strong>{facilityToDelete.Name}</strong></> : " this facility type"}?
          </CModalBody>
          <CModalFooter>
            <CButton variant="outline" color="secondary" onClick={() => setDeleteConfirmVisible(false)}>
              Cancel
            </CButton>
            <CButton color="danger" className="hrm-modal-danger-btn" onClick={confirmDelete}>
              Delete
            </CButton>
          </CModalFooter>
        </CModal>
      </div>
    </>
  )
}

const AddButton = () => {
  return (
    <>
      <CButton style={{ marginLeft: '10px' }} variant="outline" color="success">
        ADD +
      </CButton>
    </>
  )
}

export default FacilityType
